import { render, staticRenderFns } from "./SpotFeesTab.vue?vue&type=template&id=3969260d&scoped=true&"
import script from "./SpotFeesTab.vue?vue&type=script&lang=js&"
export * from "./SpotFeesTab.vue?vue&type=script&lang=js&"
import style0 from "./SpotFeesTab.vue?vue&type=style&index=0&id=3969260d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3969260d",
  null
  
)

export default component.exports